export default "__VITE_ASSET__757436f3__"